import { render, staticRenderFns } from "./SchoolSessionsEdit.vue?vue&type=template&id=f1f8c36e"
import script from "./SchoolSessionsEdit.vue?vue&type=script&lang=js"
export * from "./SchoolSessionsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports